import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { CLINIC } from '../data/clinic';
import { useLang } from '../i18n';
import { useHideOnScroll } from '../hooks/useHideOnScroll';

// Persistent, bold "Urgent? Call Now" click-to-call — desktop floating pill (mobile uses MobileCallBar).
const UrgentCall = () => {
  const { t } = useLang();
  const hidden = useHideOnScroll();
  return (
    <motion.a
      href={CLINIC.phoneHref}
      data-testid="urgent-call-btn"
      whileHover={{ y: -3 }}
      animate={{ y: hidden ? 140 : 0, opacity: hidden ? 0 : 1 }}
      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-8 right-8 z-40 hidden xl:inline-flex items-center gap-3 bg-[#1E4E8C] px-7 py-4 text-[15px] font-semibold uppercase tracking-[0.12em] text-white transition-colors hover:bg-[#17407A]"
      style={{ boxShadow: '0 16px 40px rgba(28,29,33,0.28)', pointerEvents: hidden ? 'none' : 'auto' }}
    >
      <span className="relative flex h-3 w-3">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#E8C87E] opacity-70" />
        <span className="relative inline-flex h-3 w-3 rounded-full bg-[#E8C87E]" />
      </span>
      <Phone className="h-5 w-5" />
      {t.urgent.callNow}
    </motion.a>
  );
};

export default UrgentCall;
